<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper" v-if="wtdata!==null">
          <div class="moduleCard">
            <wondertable id="tblPrivileges" :wtID="'groupPrivileges'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'This Group Has No Privileged Members'" :defaultDirection="0" ref="wt"
                         :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Privileged Members'" :burgerMenu="burgermenu" :isAdmin="isAdmin"></wondertable>
          </div>

        </div>

      </div>
    </div>
    <privileges ref="privPlugin" :poolID="poolID" v-if="poolID!==null" :allowPool="false"></privileges>
    <acfooter></acfooter>
  </div>
</template>

<style scoped>
  .privilegesBorder {
    border-bottom: 1px dashed #444;
    padding: 5px 0px;
    margin-bottom: 5px;
  }

  .privilegesButton {
    color: #6994B3;
  }

  .tree {
    margin-bottom: 15px;
  }

  .treenode {
    margin-left: 30px;
  }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"
  import privileges from "../../components/Privileges.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'GroupPrivileges',
    components: { acheader, acfooter, groupsidebar, privileges, wondertable },
    data() {
      return {
        burgermenu: [],
        groups: [],
        groupID: null,
        isAdmin: false,
        poolID: null,
        wids: ["ClientID"],
        wtdata: null,
        wtmethods: {
          add: {
            method: function (param, ref) {
              ref.add(param);
            },
            ref: this
          },
          doEdit: {
            method: function (param, ref) {
              ref.doEdit(param.ClientID);
            },
            ref: this
          }
        }
      }
    },
    methods: {
      add() {
        this.doAddEdit(null);
      },
      doAddEdit(cliID) {

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetGroupUsers",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID,
              GroupID: this.$route.params.id
            }
          }

        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.$refs["privPlugin"].groups = [];
          this.$refs["privPlugin"].groups = this.groups;
          this.$refs["privPlugin"].groups.unshift({
            LicensePoolGroupID: this.emptyguid,
            LicensePoolGroupName: "--- Select ---"
          });

          this.$refs["privPlugin"].users = [];
          this.$refs["privPlugin"].users.push({
            Name: "--- Select ---",
            ClientID: null
          })
          for (var user of JSON.parse(cr.returnObjects[0].returnObject)) {
            this.$refs["privPlugin"].users.push({ Name: this.buildNameFormat(user.FirstName, user.LastName) + "(" + user.Username + ")", ClientID: user.ClientID });
          }
          this.$refs["privPlugin"].users.sort(function (a, b) {
            let comparison = 0;
            if (a.Name > b.Name) {
              comparison = 1;
            } else if (a.Name < b.Name) {
              comparison = -1;
            }
            return comparison;
          })

          if (cliID !== null) {
            this.$refs["privPlugin"].user = cliID;
          }

          this.$refs["privPlugin"].$refs["aePrivileges"].show();
          Window.loadLanguageContent();
        })
      },

      doEdit(clientID) {
        //Hide edit button for Lifeline group admins
        if (this.sdata.activegroup.LicensePoolID != '91961f0a-b004-43a6-967d-32b36ddd66b0') {
          this.doAddEdit(clientID);
        }
        else { this.popDialog(2, "You don't have permission to edit the privileges."); }

      },
      render(force) {

        //Hide add button if user is SSO Lifeline
        const isSSOLogin =  localStorage.getItem("isSSOLogin");
        const isSimmersionUser = sessionStorage.getItem("isSimmersionUser");
        if (!isSSOLogin && !isSimmersionUser) {
          this.burgermenu = [[{ html: "Add +", value: "add" }]];
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetAllGroupPrivileges",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID,
              GroupID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetGroupSubGroups",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID,
              GroupID: this.$route.params.id
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var privs = JSON.parse(cr.returnObjects[0].returnObject);

          this.groups = JSON.parse(cr.returnObjects[1].returnObject);
          this.groups.unshift(this.sdata.activegroup);

          this.wtdata = [];

          for (var privilege of privs) {

            var needsPush = false;
            var privRecord = null;
            var pr = this.wtdata.filter(p => p.ClientID === privilege.ClientID);
            if (pr.length > 0) {
              privRecord = pr[0];
            }
            else {
              privRecord = {
                ClientID: privilege.ClientID,
                Name: this.buildNameFormat(privilege.FirstName, privilege.LastName) + "(" + privilege.Username + ")",
                GroupPrivs: ""
              }
              needsPush = true;
            }

            var gr = this.groups.filter(p => p.LicensePoolGroupID === privilege.LicensePoolGroupID)
            if (gr.length > 0) {
              privRecord.GroupPrivs += gr[0].LicensePoolGroupName + " (" + Window.getTranslatedText(privilege.AdminType) + ")<br />";
            }

            if (needsPush) {
              this.wtdata.push(privRecord);
            }
          }

          this.wtdata.sort(function compare(a, b) {
            let comparison = 0;
            if (a.Name > b.Name) {
              comparison = 1;
            } else if (a.Name < b.Name) {
              comparison = -1;
            }
            return comparison;
          });
          if (force) {
            this.$refs.wt.renderTable(this.wtdata);
          }

          this.poolID = this.sdata.activegroup.LicensePoolID;
          Window.loadLanguageContent();
        });
      },
      showHideTree(n) {
        n.ShowTree = !n.ShowTree;
      }      
    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapGroup(this.$route.params.id);
        this.render();
        Window.loadLanguageContent();
      });
      if (sessionStorage.getItem("isSimmersionUser")) {
        this.popDialog(2, "Account management is handled at the organization level. To make account related changes, please log into the Lifeline Learning Portal and visit the Users page.");
      }

    }
  }
</script>
